import { create } from 'zustand';

import { MailboxInfo } from '../types';

type InboxStore = {
  mailbox: MailboxInfo | null;
  ready: boolean;
  setMailbox: (mailbox: MailboxInfo) => void;
  setReady: (ready: boolean) => void;
};

export const useInboxStore = create<InboxStore>((set) => ({
  mailbox: null,
  ready: false,
  setMailbox: (mailbox) => set({ mailbox }),
  setReady: (ready) => set({ ready }),
}));
